.pageContent {
  display: flex;
  flex-direction: column;
  gap: 18px;
}
.header {
  padding: 8px 0;
  align-items: center;
}
.row {
  display: flex;
  gap: 18px;
}
.spacer {
  flex: 1;
}
.icon {
  display: flex;
}
.leftPane {
  display: flex;
  gap: 18px;
  flex-direction: column;
  flex: 6;
}
.rightPane {
  flex: 5;
}
.selection {
  display: flex;
  align-items: center;
  padding: 8px 0;
  font-weight: var(--font-weight-strong);
}
.shippingDetails {
  position: relative;
}
.dashes {
  position: absolute;
  height: 96px;
  left: 46px;
  top: 105px;
  border-right: 3px dotted var(--static-divider-standard, rgba(0, 0, 0, 0.12));
}
.shipmentSummary .row,
.shipmentSummary .grid {
  padding: 8px 6px;
  gap: 8px;
}
.heading {
  font-weight: var(--font-weight-strong);
  padding: 4px 0 12px 4px;
  font-size: var(--fs-small-heading);
}
.shippingIcon {
  z-index: 2;
  width: 50px;
  height: 50px;
  margin-right: 4px;
}
.grid {
  display: grid;
  grid-template-columns: 1fr max-content;
}
.grid > :nth-child(even) {
  font-weight: var(--font-weight-strong);
  text-align: right;
}
.printLabels {
  display: flex;
  flex-direction: column;
  gap: 16px;
}
.printLabelsButton {
  width: 100%;
}
